import { render } from "./Preloader.vue?vue&type=template&id=6a2ed713"
import script from "./Preloader.vue?vue&type=script&lang=js"
export * from "./Preloader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/mdbvue/pro/Components/Preloader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6a2ed713"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6a2ed713', __exports__)) {
    api.reload('6a2ed713', __exports__)
  }
  
  module.hot.accept("./Preloader.vue?vue&type=template&id=6a2ed713", () => {
    api.rerender('6a2ed713', render)
  })

}


export default __exports__